/* Built In Imports */
/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';

/* Services */

/**
 * Returns the UpcomingDates.
 * @param {Object} sectionContent - Content from API
 * @param {string} region - region of page
 * @param {string} lang - language of page
 * @returns {ReactElement} UpcomingDates component
 */
const UpcomingDates = ({ sectionContent, region, lang }) => {
  return (
    <Box
      display={'flex'}
      justifyContent={'space-around'}
      alignItems={'center'}
      textAlign={'center'}
      mb="2vw"
      fontWeight={'500'}
      className="upcomingDates"
    >
      <style global jsx>
        {`
          .upcomingDates p {
            font-family: 'FedraSansStd-book';
            font-size: 20px;
            color: #000000;
            text-align: center;
            line-height: 1.7;
          }
          .upcomingDates b {
            font-family: 'FedraSansStd-medium';
            font-size: 18px;
            color: #000000;
            text-align: center;
            line-height: 1.42857143;
          }
        `}
      </style>
      <Box
        p={'5vw'}
        w={{ xl: '60%', md: '100%' }}
        bgColor="rgb(#f5f0e5)"
        textAlign="center"
        padding="42px 29px 41px 46px"
      >
        <Box
          as={'h2'}
          fontSize={{ xl: '30px', base: '16px' }}
          fontWeight={500}
          lineHeight="1.5"
          textAlign="center"
          color="#28231e"
          fontFamily="FedraSansStd-A-medium"
        >
          {sectionContent.title}
        </Box>
        <Box
          as={'p'}
          fontSize={{ xl: '20px', base: '16px' }}
          lineHeight="1.5"
          textAlign="center"
          color="#28231e"
          mt="26px"
          fontFamily="FedraSansStd-book"
        >
          <StructuredTextParser
            str={render(sectionContent.description)}
            region={region}
            lang={lang}
          />
          {/* <ContentArea mainContent={sectionContent.description} /> */}
        </Box>
        <Box mt="26px" fontFamily="FedraSansStd-medium">
          {/* <Box
            as="b"
            fontSize={{ xl: '20px', base: '16px' }}
            fontWeight={500}
            lineHeight="1.5"
            textAlign="center"
            color="#28231e"
          >
            For Bookings
          </Box> */}
          <Box
            as="span"
            fontSize={{ xl: '20px', base: '16px' }}
            lineHeight="1.5"
            textAlign="center"
            color="#28231e"
          >
            <StructuredTextParser
              str={render(sectionContent.phone)}
              region={region}
              lang={lang}
            />
            {/* <ContentArea mainContent={sectionContent.phone} /> */}
          </Box>
          <Box>
            <Box
              as="b"
              fontSize={{ xl: '20px', base: '16px' }}
              fontWeight={500}
              lineHeight="1.5"
              textAlign="center"
              color="#28231e"
            >
              <StructuredTextParser
                str={render(sectionContent.email)}
                region={region}
                lang={lang}
              />
            </Box>
          </Box>
        </Box>
        {!sectionContent.cta ||
          (sectionContent.cta?.length < 1 && (
            <Box
              as={'a'}
              fontSize={{ xl: '20px', base: '16px' }}
              lineHeight="1.5"
              textAlign="center"
              color="#28231e"
              marginTop="15px"
              display="flex"
              justifyContent="center"
              textDecoration="underline"
            >
              <Link
                href={`${config.cdnPath}/center/consecrated-spaces/adiyogi-abode-of-yoga/processess-and-offerings/terms-and-conditions`}
                // href="https://isha.sadhguru.org/center/consecrated-spaces/adiyogi-abode-of-yoga/processess-and-offerings/terms-and-conditions"
                color="#cf4824"
                fontFamily="FedraSansStd-book"
              >
                Terms and Conditions
              </Link>
            </Box>
          ))}

        {sectionContent.cta?.length > 0 && (
          <Box
            as={'a'}
            fontSize={{ xl: '20px', base: '16px' }}
            lineHeight="1.5"
            textAlign="center"
            color="#28231e"
            marginTop="55px"
            display="flex"
            justifyContent="center"
            textDecoration="underline"
          >
            <SimpleButton
              style={sectionContent.cta[0]}
              region={region}
              lang={lang}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default UpcomingDates;
